import React, { useState } from 'react';
import Select from "react-select";
import withReactContent from 'sweetalert2-react-content';
import swal from 'sweetalert2';

import { allowedSigns, enables, requireds } from '../constants';

import './FieldModal.sass';

const MySwal = withReactContent(swal);

export const AddFieldModal = ({ handleSubmit }) => {
  const [fieldData, setFieldData] = useState({
    name: '',
    isEnabled: true,
    isRequired: true,
  });

  const handleChangeFieldSetting = (key, value) => {
    if (!allowedSigns.test(value) || value.length > 30) return;

    setFieldData((prev) => ({
      ...prev,
      [key]: value,
    }));
  }

  return (
    <div className="add-field-modal">
      <h3 className="add-field-modal__title">Add new field</h3>
      <div className="add-field-modal__settings">
        <div className="add-field-modal__input-block">
          <label>Field name</label>
          <input
            type="text"
            name="name"
            value={fieldData.name}
            placeholder="Enter field name"
            minLength="3"
            maxLength="500"
            onChange={(e) => handleChangeFieldSetting('name', e.target.value.trimStart())}
          />
        </div>
        <Select
          options={requireds}
          name="isRequired"
          value={requireds.find(({ value }) => fieldData.isRequired === value)}
          onChange={(value) => handleChangeFieldSetting('isRequired', value.value)}
          classNamePrefix="custom-select"
          className="partizan-open-selling__select"
        />
        <Select
          options={enables}
          name="isEnabled"
          value={enables.find(({ value }) => fieldData.isEnabled === value)}
          onChange={(value) => handleChangeFieldSetting('isEnabled', value.value)}
          classNamePrefix="custom-select"
          className="partizan-open-selling__select"
        />
      </div>

      <div className="add-field-modal__actions">
        <button
          className="btn-secondary"
          onClick={() => MySwal.close()}
        >
          Cancel
        </button>
        <button
          className="btn-primary"
          onClick={() => handleSubmit(fieldData)}
          disabled={!fieldData.name}
        >
          Add
        </button>
      </div>
    </div>
  )
}
